import React from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers";

export const InputTime = (props) => {
  const {
    label,
    id,
    selectedValue,
    onChange,
    isRequired,
    isError,
    hour12,
    stepMinutes,
    displayType,
  } = props;

  return (
    <div style={{ display: displayType }}>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            * {displayType !== "grid" && " "}
          </label>
        )}
      </label>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopTimePicker
          value={dayjs(selectedValue)}
          ampm={hour12}
          variant="outlined"
          slotProps={{ textField: { size: "small", error: isError } }}
          id={id}
          onChange={onChange}
          required={isRequired}
          minutesStep={stepMinutes}
          skipDisabled={true}
          views={stepMinutes === 60 ? ["hours"] : ["hours", "minutes"]}
        />
      </LocalizationProvider>
    </div>
  );
};
